import React from "react";

export function ViewIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="1em" height="1em" viewBox="0 0 16.0 16.0" version="1.1">
      <path d="M 8,3 C 3.7197932,3 0.25,5.2385763 0.25,8 c 0,2.761424 3.4697932,5 7.75,5 4.280207,0 7.75,-2.238576 7.75,-5 C 15.75,5.2385763 12.280207,3 8,3 Z M 8,4.0195312 C 10.198245,4.0197896 11.980211,5.8017548 11.980469,8 11.980211,10.198245 10.198245,11.980211 8,11.980469 5.8017548,11.980211 4.0197895,10.198245 4.0195312,8 4.0197897,5.8017548 5.8017548,4.0197896 8,4.0195312 Z M 7.8584795,4.9407834 C 6.8254944,4.7676538 5.1389784,6.5185669 5.7632211,7.192528 6.8639392,8.0955025 7.3892722,6.633497 7.987549,6.3562258 8.7988039,5.9802502 8.4037432,5.0321703 7.8584795,4.9407834 Z" />
    </svg>
  );
}
